import React, {Component} from "react";
import {Button, Col, FormGroup, Input, Label, Media, Progress, Row,} from "reactstrap";
import Wallet from "../../../../assets/images/request-session-wallet-balance-icon.svg";
import assets from "../../../../util/assets";
import {vuepayAlert, vuePayLog} from "../../../../util/utility";
import "./index.css";

export default class TipGoalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //balance: "0.00",
            removeCloseButton: false,
            tipValue: "0.01",
            sendTipButtonStatus: false,
            lowBalanceAlert: false,
            dynamicTipData: [
                {
                    amount: 0.01,
                    value: "1p",
                    status: true,
                    text: "Show me love",
                    image: assets.tip.showmelove,
                    right: 55,
                    top: -14
                },
                {
                    amount: 0.10,
                    value: "10p",
                    status: false,
                    text: "Thank me",
                    image: assets.tip.thankme,
                    right: 45,
                    top: -14
                },
                {
                    amount: 0.50,
                    value: "50p",
                    status: false,
                    text: "Wow me",
                    image: assets.tip.wowme,
                    right: 45,
                    top: -14
                },
                {
                    amount: 1,
                    value: "£1",
                    status: false,
                    text: "Suprise me",
                    image: assets.tip.impress,
                    right: 45,
                    top: -14
                },
                {
                    amount: 5,
                    value: "£5",
                    status: false,
                    text: "Buy me a coffee",
                    image: assets.tip.coffee,
                    right: 45,
                    top: -6
                },
                {
                    amount: 10,
                    value: "£10",
                    status: false,
                    text: "Buy me a meal",
                    image: assets.tip.meal,
                    right: 72,
                    top: -6
                },
                {
                    amount: 25,
                    value: "£25",
                    status: false,
                    text: "Buy me a gift",
                    image: assets.tip.gift,
                    right: 45,
                    top: -16
                },
                {
                    amount: 50,
                    value: "£50",
                    status: false,
                    text: "Impress me",
                    image: assets.tip.impress,
                    right: 45,
                    top: -14
                },
                {
                    amount: -1,
                    value: "other",
                    status: false,
                    text: "Surprise me",
                    image: assets.tip.impress,
                    right: 45,
                    top: -14
                },
            ],
            isFetching:false
        };
    }

    modalOpenRender = () => {

        this.setState({tipValue: "5.00"});
        this.setState({lowBalanceAlert: false});
        this.setState({sendTipButtonStatus: false});
        this.setState({removeCloseButton: false});

        if (Number(this.props.balance) >= Number(this.state.tipValue)) {

            this.setState({lowBalanceAlert: false});
        } else {

            this.setState({lowBalanceAlert: true});
        }

        return this.props.tipGoalButtonActive ||
        this.props.tipGoalMessage ||
        this.props.maximumtipStatus
            ? this.setState({
                dynamicTipData: this.state.dynamicTipData.map((tip) => {
                    return tip.value === "£5"
                        ? {...tip, status: true}
                        : {...tip, status: false};
                }),
            })
            : "";
    };

    componentDidMount() {
        this.modalOpenRender();
    }

    tipValueValidation = (e) => {

        this.setState({
            tipValue: e.target.value === 0 ? null : Number(e.target.value),
        });

        let floorValue = Math.floor(e.target.value);
        // Low Balance alert
        if (Number(this.props.balance) >= Number(e.target.value)) {
            //
            this.setState({lowBalanceAlert: false});
        } else {
            //
            this.setState({lowBalanceAlert: true});
        }

        if (floorValue === "5") {
            this.setState({
                dynamicTipData: this.state.dynamicTipData.map((tip) => {
                    return tip.value === `£${floorValue}`
                        ? {...tip, status: true}
                        : {...tip, status: false};
                }),
            });
        } else if (floorValue === "10") {
            this.setState({
                dynamicTipData: this.state.dynamicTipData.map((tip) => {
                    return tip.value === `£${floorValue}`
                        ? {...tip, status: true}
                        : {...tip, status: false};
                }),
            });
        } else if (floorValue === "25") {
            this.setState({
                dynamicTipData: this.state.dynamicTipData.map((tip) => {
                    return tip.value === `£${floorValue}`
                        ? {...tip, status: true}
                        : {...tip, status: false};
                }),
            });
        } else if (floorValue === "50") {
            this.setState({
                dynamicTipData: this.state.dynamicTipData.map((tip) => {
                    return tip.value === `£${floorValue}`
                        ? {...tip, status: true}
                        : {...tip, status: false};
                }),
            });
        } else {
            this.setState({
                dynamicTipData: this.state.dynamicTipData.map((tip) => {
                    return tip.value === "other"
                        ? {...tip, status: true}
                        : {...tip, status: false};
                }),
            });
        }
    };

    handleSubmitTip = () => {

        if (this.state.tipValue !== 0 && this.state.tipValue != null) {
            if (this.state.tipValue > 0 && this.state.tipValue <= 100) {
                this.setState({removeCloseButton: true});
                this.modalOpenRender();

                if(this.props.tipAmountSend){
                    //send this to parent class
                    this.props.tipAmountSend(Number(this.state.tipValue));
                }

                this.props.tipGoalRequest(
                    Number(this.state.tipValue) * 100,
                    "ongoing_broadcast"
                );

                this.setState({
                    isFetching:true
                });

            } else {
                vuepayAlert("error", "Please, Enter Tip value between £1 and £100");
            }
        } else {
            vuepayAlert("error", "Please, Enter Tip value between £1 and £100");
        }
    };

    render() {
        const sessionStyle = {
            tipText: {
                // height: "22px",
                // width: "24px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "37px",
            },
            closeButton: {
                height: "14px",
                width: "13px",
                backgroundColor: "#58595B",
            },
            // coffeeTextWidth: {
            //     height: "56px",
            //     width: "336px",
            //     opacity: "005",
            //     backgroundColor: "#1B75BC",
            // },
            coffeeImageSize: {
                height: "69.33px",
                width: "72px",
            },
            tipGoalAmountText: {
                height: "19px",
                width: "149px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                letterSpacing: "0",
                lineHeight: "19px",
            },
            coffeeTextWidth: {
                height: "32px",
                width: "78px",
                borderRadius: "2px",
                backgroundColor: "#1B75BC",
            },
            coffeeText: {
                height: "19px",
                //width: "114px",
                color: "#1B75BC",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "left",
                margin: "6% 0%",
            },
            pleaseSelectAddText: {
                //height: "19px",
                //width: "270px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            or: {
                height: "19px",
                width: "20px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                letterSpacing: "0",
                lineHeight: "19px",
            },
            min: {
                height: "19px",
                width: "49px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "right",
            },
            walletText: {
                //height: 19px,
                //width: 96px,
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                letterSpacing: "0",
                lineHeight: "19px",
            },
            noteText: {
                //height: 19px,
                //width: 96px,
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "11px",
                letterSpacing: "0",
                lineHeight: "19px",
            },
            walletValue: {
                //height: 19px,
                //width: 44px,
                color: "#1B75BC",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "right",
            },
            creditLink: {
                //height: 19px,
                //width: 67px,
                color: "#1B75BC",
                fontFamily: "Open Sans",
                fontSize: "14px",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
                textDecoration: "underline",
            },
            sendTipButtonWidth: {
                //height: "40px",
                width: "100%",
            },
            sendTipButton: {
                //height: "19px",
                //width: "62px",
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            inputBoxStyle: {
                border: "1px solid #58595B !important",
                opacity: "0.5 !important",
                borderRadius: "2px !important",
                backgroundColor: "#FFFFFF",
                color: "#58595B !important",
                fontFamily: "Open Sans",
                fontWeight: "600 !important",
                letterSpacing: "0 !important",
                lineHeight: "19px !important",
            },
            nonAmountSelectButtonSize: {
                height: "32px",
                width: "78px",
                //opacity: "0.1",
                borderRadius: "2px",
                //backgroundColor: "#E8F1F8",
                textIndent: "0px",
                //height: "auto",
                //width: "auto",
            },
            nonAmountSelectButtonText: {
                //height: 17px;
                //width: 75px;
                //color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "12px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "17px",
                textAlign: "center",
            },
            amountSelectButtonSize: {
                height: "32px",
                width: "78px",
                //opacity: "0.1",
                borderRadius: "2px",
                backgroundColor: "#1B75BC",
                textIndent: "0px",
                //height: "auto",
                //width: "auto",
            },
            amountSelectButtonText: {
                //height: 17px;
                //width: 75px;
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "12px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "17px",
                textAlign: "center",
            },
        };

        return (
            <div className="chat-component-container">
                <div>
                    <Row className="chat-component-header-container">
                        <Col className="chat-component-header">Like Goal</Col>
                        <Col className="chat-component-header-close">
                            <img src={assets.broadcast.cross}
                                 onClick={() => {
                                     vuePayLog("TipGoalComponent", "", "Cross icon clicked");
                                     this.props.setRightLayout("");
                                 }}
                                 alt="cross icon"
                                 width={13}/>
                        </Col>
                    </Row>
                    <div className="chat-component-header-divider "/>
                </div>

                <Row className="mx-0 tip-goal-middle-content">
                    <Col sm="12" className="px-0 full-width padding-16" style={{textAlign:'left'}}>
                        {this.props.maximumtipStatus ? (
                            <Media className="p-2 mt-2 bg-primary">
                                <Media left middle href="#">
                                    <Media
                                        object
                                        src={assets.thank_you_hand_white_bg}
                                        alt="Generic placeholder image"
                                        style={{width: "56px", height: "42.25px"}}
                                        className="my-4"
                                    />
                                </Media>
                                <Media body>
                                    <Row className="mx-0">
                                        <Col md="12" sm="12" className="text-left">
                                            <Media heading className="text-left">
                      <span
                          className="text-white"
                          style={sessionStyle.pleaseSelectAddText}
                      >
                        The broadcaster has reached its goal of raising fund.
                      </span>
                                            </Media>
                                            {/*<span className="tip-goal-amount text-white">
                  Tip Goal Amount: £10.00
        </span>*/}
                                        </Col>
                                        {/*<Col md="3" sm="3" className="p-0">
                <p
                  className="text-right text-white tip-goal-amount"
                  style={{ margin: "34% 0%" }}
                >
                  Time: 02:25PM
                </p>
      </Col>*/}
                                    </Row>
                                </Media>
                            </Media>
                        ) : (
                            this.props.tipGoalMessage && (
                                <Media className="p-2 mt-2 bg-primary">
                                    <Media left middle href="#">
                                        <Media
                                            object
                                            src={assets.thank_you_hand_white_bg}
                                            alt="Generic placeholder image"
                                            style={{width: "56px", height: "42.25px"}}
                                            className="my-4"
                                        />
                                    </Media>
                                    <Media body>
                                        <Row className="mx-0">
                                            <Col md="12" sm="12" className="text-left">
                                                <Media heading className="text-left">
                        <span
                            className="text-white"
                            style={sessionStyle.pleaseSelectAddText}
                        >
                          {this.props.tipGoalMessage.message}
                        </span>
                                                </Media>
                                                {/*<span className="tip-goal-amount text-white">
                    Tip Goal Amount: £10.00
          </span>*/}
                                            </Col>
                                            {/*<Col md="3" sm="3" className="p-0">
                  <p
                    className="text-right text-white tip-goal-amount"
                    style={{ margin: "34% 0%" }}
                  >
                    Time: 02:25PM
                  </p>
        </Col>*/}
                                        </Row>
                                    </Media>
                                </Media>
                            )
                        )}

                        <div className="p-2 mt-2" style={{backgroundColor: "#E8F1F8"}}>
                            <Row className="mt-1">
                                <Col md="12" sm="12">
                <span style={sessionStyle.pleaseSelectAddText}>
                  {this.props.tipGoalPurpose}
                </span>
                                </Col>
                                {/*<Col md="3" sm="12" className="p-0">
                <span className="hourText">3hr left</span>
      </Col>*/}
                            </Row>

                            <Row className="mt-3">
                                <Col md="4">
                <span style={sessionStyle.pleaseSelectAddText}>
                  {this.props.tipGoalData && this.props.tipGoalData.total_contributors}
                </span>
                                </Col>
                                <Col md="4">
                <span style={sessionStyle.pleaseSelectAddText}>
                  {this.props.tipGoalData && this.props.tipGoalData.total_tip_amount_formatted}
                </span>
                                </Col>
                                <Col md="4">
                <span style={sessionStyle.pleaseSelectAddText}>
                  {this.props.tipGoalData && this.props.tipGoalData.tip_goal_amount_formatted}
                </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="4">
                                    <span className="goalRegdText">Contributions</span>
                                </Col>
                                <Col md="4">
                                    <span className="goalRegdText">raised</span>
                                </Col>
                                <Col md="4">
                                    <span className="goalRegdText">goal</span>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col md="10">
                                    <div className="progressbarBackgroundColor">

                                        <Progress
                                            bar
                                            color="success"
                                            value={this.props.tipGoalData && this.props.tipGoalData.percentage / 100 > 1 ? 100 : this.props.tipGoalData.percentage}
                                            style={{height: "10px", borderRadius: "2px"}}
                                        />
                                    </div>
                                </Col>
                                <Col md="2" className="px-0">
                <span className="progressbarText">
                  {this.props.tipGoalData && this.props.tipGoalData.percentage}%
                </span>
                                </Col>
                            </Row>
                        </div>
                        {this.props.maximumtipStatus
                            ? ""
                            : !this.props.tipGoalMessage && (
                            <React.Fragment>
                                <Row className="mt-2">
                                    <Col md="12" className="text-left col-12">
                                        <FormGroup>
                                            <Label className="text-left">
                          <span className="enter-tip-goal-amount-title">
                            Enter Like Goal Amount
                          </span>
                                            </Label>
                                            <Input
                                                className="tip-goal-input"
                                                type="number"
                                                name="tipAmount"
                                                size="lg"
                                                //style={sessionStyle.inputBoxStyle}
                                                placeholder="0.00"
                                                onChange={this.tipValueValidation}
                                                value={this.state.tipValue}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <p className="text-left" style={sessionStyle.or}>
                                    OR
                                </p>
                                <p
                                    className="text-left please-select-add-title"
                                >
                                    Please select & add your top-up amount
                                </p>
                                <Row className="mx-0">
                                    <Col md="3" className="px-0 my-md-0 my-sm-2">
                                        <Button
                                            color="primary"
                                            style={sessionStyle.nonAmountSelectButtonSize}
                                            className={this.state.dynamicTipData.map((tip) => {
                                                return tip.value === "£5"
                                                    ? tip.status === true
                                                        ? "p-0 amountSelectButtonSize"
                                                        : ""
                                                    : "p-0 nonAmountSelectButtonSize";
                                            })}
                                            size="sm"
                                            onClick={() => {
                                                this.setState({
                                                    dynamicTipData: this.state.dynamicTipData.map(
                                                        (tip) => {
                                                            return tip.value === "£5"
                                                                ? {...tip, status: true}
                                                                : {...tip, status: false};
                                                        }
                                                    ),
                                                });
                                                // Low Balance alert
                                                if (Number(this.props.balance) >= Number("5.00")) {
                                                    //
                                                    this.setState({lowBalanceAlert: false});
                                                } else {
                                                    //
                                                    this.setState({lowBalanceAlert: true});
                                                }
                                                this.setState({tipValue: "5.00"});
                                            }}
                                        >
                                            <span style={sessionStyle.nonAmountSelectButtonText}>
                                              £5{" "}
                                                {this.state.dynamicTipData.map((tip) => {
                                                    return tip.value === "£5" ? (
                                                        tip.status === true ? (
                                                            <i className="fa fa-check" aria-hidden="true"></i>
                                                        ) : (
                                                            ""
                                                        )
                                                    ) : (
                                                        ""
                                                    );
                                                })}
                                            </span>
                                        </Button>
                                    </Col>
                                    <Col md="3" className="px-0 my-md-0 my-sm-2">
                                        <Button
                                            color="primary"
                                            style={sessionStyle.nonAmountSelectButtonSize}
                                            className={this.state.dynamicTipData.map((tip) => {
                                                return tip.value === "£10"
                                                    ? tip.status === true
                                                        ? "p-0 amountSelectButtonSize"
                                                        : ""
                                                    : "p-0 nonAmountSelectButtonSize";
                                            })}
                                            size="sm"
                                            onClick={() => {
                                                this.setState({
                                                    dynamicTipData: this.state.dynamicTipData.map(
                                                        (tip) => {
                                                            return tip.value === "£10"
                                                                ? {...tip, status: true}
                                                                : {...tip, status: false};
                                                        }
                                                    ),
                                                });
                                                // Low Balance alert
                                                if (Number(this.props.balance) >= Number("10.00")) {
                                                    //
                                                    this.setState({lowBalanceAlert: false});
                                                } else {
                                                    //
                                                    this.setState({lowBalanceAlert: true});
                                                }
                                                this.setState({tipValue: "10.00"});
                                            }}
                                        >
                                        <span style={sessionStyle.nonAmountSelectButtonText}>
                                          £10{" "}
                                            {this.state.dynamicTipData.map((tip) => {
                                                return tip.value === "£10" ? (
                                                    tip.status === true ? (
                                                        <i className="fa fa-check" aria-hidden="true"></i>
                                                    ) : (
                                                        ""
                                                    )
                                                ) : (
                                                    ""
                                                );
                                            })}
                                        </span>
                                        </Button>
                                    </Col>
                                    <Col md="3" className="px-0 my-md-0 my-sm-2">
                                        <Button
                                            color="primary"
                                            className="p-0"
                                            style={sessionStyle.nonAmountSelectButtonSize}
                                            className={this.state.dynamicTipData.map((tip) => {
                                                return tip.value === "£25"
                                                    ? tip.status === true
                                                        ? "p-0 amountSelectButtonSize"
                                                        : ""
                                                    : "p-0 nonAmountSelectButtonSize";
                                            })}
                                            size="sm"
                                            onClick={() => {
                                                this.setState({
                                                    dynamicTipData: this.state.dynamicTipData.map(
                                                        (tip) => {
                                                            return tip.value === "£25"
                                                                ? {...tip, status: true}
                                                                : {...tip, status: false};
                                                        }
                                                    ),
                                                });
                                                // Low Balance alert
                                                if (Number(this.props.balance) >= Number("25.00")) {
                                                    //
                                                    this.setState({lowBalanceAlert: false});
                                                } else {
                                                    //
                                                    this.setState({lowBalanceAlert: true});
                                                }
                                                this.setState({tipValue: "25.00"});
                                            }}
                                        >
                        <span style={sessionStyle.nonAmountSelectButtonText}>
                          £25{" "}
                            {this.state.dynamicTipData.map((tip) => {
                                return tip.value === "£25" ? (
                                    tip.status === true ? (
                                        <i className="fa fa-check" aria-hidden="true"></i>
                                    ) : (
                                        ""
                                    )
                                ) : (
                                    ""
                                );
                            })}
                        </span>
                                        </Button>
                                    </Col>
                                    <Col md="3" className="px-0 my-md-0 my-sm-2">
                                        <Button
                                            color="primary"
                                            className="p-0"
                                            style={sessionStyle.nonAmountSelectButtonSize}
                                            className={this.state.dynamicTipData.map((tip) => {
                                                return tip.value === "£50"
                                                    ? tip.status === true
                                                        ? "p-0 amountSelectButtonSize"
                                                        : ""
                                                    : "p-0 nonAmountSelectButtonSize";
                                            })}
                                            size="sm"
                                            onClick={() => {
                                                this.setState({
                                                    dynamicTipData: this.state.dynamicTipData.map(
                                                        (tip) => {
                                                            return tip.value === "£50"
                                                                ? {...tip, status: true}
                                                                : {...tip, status: false};
                                                        }
                                                    ),
                                                });
                                                // Low Balance alert
                                                if (Number(this.props.balance) >= Number("50.00")) {
                                                    //
                                                    this.setState({lowBalanceAlert: false});
                                                } else {
                                                    //
                                                    this.setState({lowBalanceAlert: true});
                                                }
                                                this.setState({tipValue: "50.00"});
                                            }}
                                        >
                        <span style={sessionStyle.nonAmountSelectButtonText}>
                          £50{" "}
                            {this.state.dynamicTipData.map((tip) => {
                                return tip.value === "£50" ? (
                                    tip.status === true ? (
                                        <i className="fa fa-check" aria-hidden="true"></i>
                                    ) : (
                                        ""
                                    )
                                ) : (
                                    ""
                                );
                            })}
                        </span>
                                        </Button>
                                    </Col>
                                </Row>

                                <Media
                                    className="p-2 mt-2"
                                    style={{backgroundColor: "#F6F6F7"}}
                                >
                                    <Media left bottom href="#">
                                        <Media
                                            object
                                            src={Wallet}
                                            alt="Generic placeholder image"
                                            style={{width: "40px", height: "40px"}}
                                            className="rounded-circle my-2"
                                        />
                                    </Media>
                                    <Media body>
                                        <Row className="mx-0">
                                            <Col md="7" sm="7" className="text-left p-0">
                                                <Media heading className="text-left">
                            <span
                                className="ml-2"
                                style={sessionStyle.walletText}
                            >
                              Wallet Balance
                            </span>
                                                </Media>
                                                <span
                                                    className="ml-2"
                                                    style={sessionStyle.walletValue}
                                                >
                            £{this.props.balance}
                          </span>
                                            </Col>
                                            <Col md="3" sm="3" className="p-0">
                                                <Button
                                                    outline
                                                    color="primary"
                                                    size="sm"
                                                    className="my-2 p-2 btn btn-outline-primary btn-sm font-weight-light"
                                                    {...(this.state.lowBalanceAlert
                                                        ? {
                                                            style: {
                                                                textIndent: "0px",
                                                                height: "auto",
                                                                width: "auto",
                                                                border: "1px solid #E25454",
                                                                borderRadius: "2px !important",
                                                                background: "rgb(246 246 247)",
                                                            },
                                                        }
                                                        : {
                                                            style: {
                                                                textIndent: "0px",
                                                                height: "auto",
                                                                width: "auto",
                                                                border: "1px solid #1B75BC",
                                                                borderRadius: "2px !important",
                                                                background: "rgb(246 246 247)",
                                                            },
                                                        })}
                                                    onClick={() => {
                                                        this.props.addBalance();
                                                    }}
                                                >
                            <span
                                className="add-credit-btn-text"
                                {...(this.state.lowBalanceAlert
                                    ? {style: {color: "#E25454"}}
                                    : {style: {color: "#1B75BC"}})}
                            >
                              Add credit
                            </span>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Media>
                                </Media>
                            </React.Fragment>
                        )}
                    </Col>
                </Row>

                {/*Bottom button*/}
                <Row className="request-button-container">
                    <Col md="12" sm="12" className="text-center">
                        {/*<Button*/}
                            {/*color="primary tip-modal-send-tip-button"*/}
                            {/*style={this.state.lowBalanceAlert ? {opacity: '0.5'} : {}}*/}
                            {/*onClick={this.handleSubmitTip}>*/}
                            {/*<span className="tip-modal-send-tip-button-text">SEND TIP</span>*/}
                        {/*</Button>*/}
                        {
                            this.props.maximumtipStatus ? (
                                ""
                            ) : this.props.tipGoalMessage === null ? (
                                <Button
                                    color="primary"
                                    className="request-button"
                                    onClick={() => {
                                        this.handleSubmitTip();
                                    }}
                                >
                                    {this.state.isFetching ? (
                                        <img
                                            src={assets.loading_white}
                                            alt={"Loading"}
                                            width={26}
                                            height={26}
                                        />
                                    ) : (
                                       "CONFIRM"
                                    )}
                                </Button>
                            ) : (
                                <Button
                                    color="primary"
                                    className="request-button"
                                    onClick={() => {
                                        this.props.tipAgainRequestTipGoal();
                                        this.modalOpenRender();
                                        this.setState({
                                            isFetching:false
                                        });
                                    }}
                                >
                                   TIP AGAIN
                                </Button>
                            )
                        }
                    </Col>
                </Row>


                </div>
        );
    }
}
